import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

export const RoundTriangle: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(({ size = 24, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.32541 13.7358C6.43715 15.9239 9.56286 15.9239 10.6746 13.7358L15.3117 4.60887C16.3257 2.6131 14.8757 0.25 12.6371 0.25H3.36292C1.12434 0.25 -0.32566 2.61311 0.688328 4.60888L5.32541 13.7358Z"
        fill="currentColor"
      />
    </svg>
  )
})

RoundTriangle.displayName = 'RoundTriangle'
